<template>
	<div class="page page_baocuo">
		<div class="filed">
			<div class="filed_title">举报内容</div>
			<div class="filed_nr">
				<van-field v-model="info" type="textarea" placeholder="请输入..." />
			</div>
		</div>
		<div class="filed">
			<div class="filed_title">举报图片</div>
			<div class="filed_nr">
				<div class="upload-images">
					<div class="img-box" v-for="(item, index) in imglist" :key="index">
						<div class="icon-po">
							<van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" />
						</div>
						<div class="del" @click="imgDel(index)"></div>
					</div>
					<van-uploader :after-read="onRead" accept multiple max-count="9" class="icon-add" ref="addPhone">
						<div class="addPhone"></div>
					</van-uploader>
				</div>
			</div>
		</div>
		<div class="actions">
			<div class="bottom_action" @click="tijiaoFun">提交</div>
		</div>
		<!-- loading -->
		<van-overlay :show="showloading">
			<van-loading class="soltloading" />
		</van-overlay>
	</div>
</template>
<script>
import Vue from 'vue';
import Bridge from '../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
	data(){
		return{
			token: null,
			info: null,
			imglist: [], // 上传回显图片列表
			showloading: false,
			imageUrl: this.$publicData.uploadImage
		}
	},
	created() {
		var that = this
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    naviTitle: '我要举报',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
			//获取用户信息
            var memberParams = {
                'data': {
                    
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token

                } else {
                    this.token = ''
                }
            })
		} else {
			this.token = this.$store.getters.token
		}
	},
	methods: {
		// 提交
		tijiaoFun(){
			var that = this;
			if(!this.info){
				this.$toast('请输入描述');
                return
			};
			if(this.imglist.length == 0){
				this.$toast('请上传图片');
                return
			};
			let album = this.imglist.join(',');
			let params = {
				token: this.token,
				info: this.info,
				album: album
			};
			that.showloading = true;
			this.$api.index.chatjubao(params).then(res=>{
				if(res.code == 200){
					that.$toast('感谢您的反馈，我们会尽快核实！');
					setTimeout(() => {
						that.showloading = false;
						if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
							var params = {
								'data': {}
							}
							that.$bridge.callhandler('sdjy://public/back', params, (data) => {

							})

						} else {
							that.$router.push({
								path: '/',
							})
						}
					}, 2000);
					
				}else{
					that.showloading = false;
					this.$toast(res.message);
				}
			})
		},
		// 图片上传 
        onRead: function (file) {
            // console.log("file");
            // console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.imglist.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.imglist.push(res.result.url);
                    }
                });
            }
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
        }
	},
}
</script>
<style scoped>
	.page .upload-images {
		margin-top: .4rem;
	}
</style>